import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=6da1c06e&"
import script from "./sort.vue?vue&type=script&lang=js&"
export * from "./sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/QI.Recrutement.FE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import UiAction from '@/components/ui/action.vue'
import UiCallToAction from '@/components/ui/call-to-action.vue'
import UiGridMiddle from '@/components/ui/grid-middle.vue'
import UiIllustration from '@/components/ui/illustration.vue'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {UiAction,UiCallToAction,UiGridMiddle,UiIllustration,VBtn,VContainer,VIcon,VTooltip})
